// PersistentCarousel.tsx
import React from "react";
import { useNode } from "@craftjs/core";
import { TextField } from "@mui/material";
import { BasicCarouselPreviewComponent } from "../basic/BasicCarouselPreviewComponent";
import { EventFiltersSettings } from "@components/EventFilterSettings";

interface PersistentCarouselProps {
  title: string;
  description?: string;
  persistentStreams?: any[]; // adjust the type as needed
  connect?: any;
  drag?: any;
}

const PersistentCarouselBuilderComponent = (props: PersistentCarouselProps) => {
  const {
    connectors: { connect, drag },
  } = useNode();

  return (
    <PersistentCarouselPreviewComponent
      {...props}
      connect={connect}
      drag={drag}
    />
  );
};

export default PersistentCarouselBuilderComponent;

export const PersistentCarouselPreviewComponent = ({
  title,
  description,
  connect,
  drag,
  persistentStreams,
}: PersistentCarouselProps) => {
  return (
    <div
      ref={(ref: any) => (connect && drag ? connect(drag(ref)) : undefined)}
      className="py-4"
    >
      <BasicCarouselPreviewComponent
        title={title}
        persistentStreams={persistentStreams} // Updated prop name
        noPadding
      />
    </div>
  );
};

const PersistentCarouselSettings = () => {
  const {
    actions: { setProp },
    title,
    description,
  } = useNode((node) => ({
    title: node.data.props.title,
    description: node.data.props.description,
  }));

  return (
    <div className="w-full space-y-4">
      <TextField
        fullWidth
        label="Title"
        value={title}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setProp((prop: any) => (prop.title = e.target.value))
        }
      />

      <TextField
        fullWidth
        label="Description"
        value={description}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          setProp((prop: any) => (prop.description = e.target.value))
        }
      />

      <EventFiltersSettings includePersistentIDOptions />
    </div>
  );
};

PersistentCarouselBuilderComponent.craft = {
  props: {
    title: "Persistent Carousel",
    description:
      "Labore amet tempor nostrud enim sint laborum esse ipsum reprehenderit fugiat sit minim ea. Enim ",
  },
  displayName: "Persistent Carousel",
  related: {
    settings: PersistentCarouselSettings,
  },
};
